import { api } from "@serophin/shared";
import * as v from "valibot";

export const getHealthResponse = {
  status: v.literal("ok"),
};

export const getHealthApi = api("GET", "/health").withResponse(getHealthResponse);
